import { FIELD_TYPE } from "../../constants";
import { UploadConfig } from "./config-types";

export const MARKETPLACE_CONFIG: UploadConfig = {
    title: "Marketplace Upload",
    subtitle: "Marketplace Order Details",
    successMessage: "Your marketplace photos have been successfully uploaded!",
    maxPhotos: 200,
    fields: [
        {
            name: 'orderNumber',
            label: 'Your order number on the marketplace (Amazon, eBay, Etsy)',
            type: FIELD_TYPE.STRING,
            required: true,
        },
        {
            name: 'storyTitle',
            label: 'Your story title (Will be displayed at the beginning or end of the video)',
            type: FIELD_TYPE.STRING,
            required: true,
        }
    ],
    endpoints: {
        load: '/api/marketplace-orders',
        upload: '/api/marketplace-orders/upload',
        remove: '/api/marketplace-orders',
        updatePositions: '/api/marketplace-orders/update-positions',
        submit: '/api/marketplace-orders/submit'
    }
};

export const MARKETPLACE2_CONFIG: UploadConfig = {
    title: "Marketplace Upload",
    subtitle: "Marketplace Order Details",
    successMessage: "Your marketplace photos have been successfully uploaded!",
    maxPhotos: 150,
    fields: [
        {
            name: 'orderNumber',
            label: 'Your order number on the marketplace (Amazon, eBay, Etsy)',
            type: FIELD_TYPE.STRING,
            required: true,
        },
        {
            name: 'names',
            label: 'Your names (e.g., Anna & Wilson)',
            type: FIELD_TYPE.STRING,
            required: true,
        },
        {
            name: 'eventDate',
            label: 'Event date (e.g., August 25, 2025)',
            type: FIELD_TYPE.DATE,
            required: true,
        },
        {
            name: 'location',
            label: 'Location (e.g., Grand Hotel, 1700 East Avenue)',
            type: FIELD_TYPE.STRING,
            required: true,
        },
        {
            name: 'details',
            label: 'Details (e.g., www.ourbestevent.com)',
            type: FIELD_TYPE.STRING,
            required: false,
        },
    ],
    endpoints: {
        load: '/api/marketplace-orders-2',
        upload: '/api/marketplace-orders-2/upload',
        remove: '/api/marketplace-orders-2',
        updatePositions: '/api/marketplace-orders-2/update-positions',
        submit: '/api/marketplace-orders-2/submit'
    }
}; 